/* eslint-disable no-undef */

window.$ = window.jQuery;

import VanillaCalendar from "@uvarov.frontend/vanilla-calendar";
import 'slick-carousel';

require('@fancyapps/fancybox/dist/jquery.fancybox');

function visualSlider() {
    jQuery('.visual-slider').slick({
        dots: true,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        edgeFriction: 0.02,
        autoplaySpeed: 2500,
    });
}

function gallery() {
    // eslint-disable-next-line no-shadow
    const gallery = jQuery('.gallery-block-items').slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.gallery-block-nav',
    });
    jQuery('.gallery-block-nav').slick({
        dots: false,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 6,
        slidesToScroll: 1,
        asNavFor: '.gallery-block-items',
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 5,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
    });
    gallery.on('beforeChange', function () {
        jQuery('.gallery-block-nav-item .nr').hide();
    });
}

function contentJS() {
    let hash = window.location.hash;
    if (hash) {
        jQuery(".wp-block-yoast-faq-block .schema-faq-section").each(function () {
            if (`#${jQuery(this).attr('id')}` === hash) {
                jQuery(this).addClass('active');
            }
        });
    } else {
        jQuery(".wp-block-yoast-faq-block .schema-faq-section:first-child").each(function () {
            jQuery(this).addClass('active');
        });
    }

    jQuery(window).on('hashchange', () => {
        hash = window.location.hash;
        if (hash) {
            jQuery(".wp-block-yoast-faq-block .schema-faq-section").each(function () {
                if (`#${jQuery(this).attr('id')}` === hash) {
                    jQuery(this).addClass('active');
                } else {
                    jQuery(this).removeClass('active');
                }
            });
        }
    });

    jQuery(".wp-block-yoast-faq-block .schema-faq-section .schema-faq-question").each(function () {
        jQuery(this).click(function (e) {
            e.preventDefault();
            jQuery(".wp-block-yoast-faq-block .schema-faq-section").removeClass('active');
            jQuery(this).parent().addClass('active');
        });
    });

    jQuery(".entry-content .wp-block-gallery .wp-block-image a").each(function () {
        jQuery(this).attr('data-fancybox', 'gallery');
    });
}

function eventsFilter() {
    jQuery('.events-filters select').change(function () {
        jQuery('.events').addClass('fade');
        jQuery('.events-filters form').submit();
    });
}

function calendar() {
    // eslint-disable-next-line no-shadow
    const calendar = new VanillaCalendar('#calendar', calendar_options);
    calendar.init();
}

function eventGallery() {
    // eslint-disable-next-line no-shadow
    const eventGallery = jQuery('.event-gallery');
    // eslint-disable-next-line no-shadow
    const gallery = eventGallery.find('.gallery');
    const photo = eventGallery.find('.photo');
    const video = photo.find('.video');
    const iframe = video.find('iframe');
    const imageLinks = gallery.find('a.image');
    const youtubeLinks = gallery.find('a.youtube');
    const image = photo.find('img');

    imageLinks.click(function (e) {
        e.preventDefault();
        const thisLink = jQuery(this);
        const thisHref = thisLink.attr('href');

        video.hide();
        iframe.attr('src', '');
        gallery.find('a').removeClass('active');
        thisLink.addClass('active');
        image.attr('src', thisHref).show();
    });

    youtubeLinks.click(function (e) {
        e.preventDefault();
        const thisLink = jQuery(this);
        const thisHref = thisLink.attr('href');

        image.hide();
        iframe.attr('src', thisHref);
        video.show();
    });
}

function loadPosts() {
    jQuery('.btn-more-ajax').click(function (e) {
        e.preventDefault();
        const data_this = jQuery(this);
        const data_load_type = jQuery(this).attr('data-load-type');
        const data_load_start = parseInt(jQuery(this).attr('data-load-start'));
        const data_load_more = parseInt(jQuery(this).attr('data-load-more'));
        jQuery.ajax({
            data: {
                data_load_type,
                data_load_start,
                data_load_more,
            },
            type: 'POST',
            url: theme.ajax_url + '?action=load_posts',
            beforeSend() {
                data_this.css("pointer-events", "none");
            },
            error() {
                data_this.css("pointer-events", "all");
            },
            success(response) {
                if (response.valid) {
                    jQuery(`.container .${data_load_type}`).append(response.html);
                    data_this.css("pointer-events", "all");
                    data_this.attr("data-load-start", (data_load_start + data_load_more));
                    if (response.last) {
                        data_this.hide();
                    }
                } else {
                    data_this.hide();
                }
            },
        });
    });
}

function mobileNav() {
    jQuery('.mobile-nav').on('click', function (e) {
        e.preventDefault();
        const header_menu = jQuery('.site-header-items .primary-navigation');
        if (header_menu.hasClass('active')) {
            header_menu.slideUp();
            header_menu.removeClass('active');
        } else {
            header_menu.slideDown();
            header_menu.addClass('active');
        }
    });

    jQuery('.toggle-sub-menu').on('click', function () {
        const parent = jQuery(this).parent();
        if (parent) {
            parent.toggleClass('sub-menu-open');
        }
    });
}

function eventMore() {
    const content_height = jQuery('.event-content').height();
    if (content_height > 500) {
        jQuery('.event-content').addClass('big');
    }
    jQuery('.btn-toggle-more').on('click', function (e) {
        e.preventDefault();
        jQuery(this).toggleClass('active');
        jQuery('.event-content.big').toggleClass('big-full');
    });
}

function logosSlider() {
    jQuery('.logos-list').slick({
        dots: true,
        arrows: true,
        infinite: false,
        speed: 300,
        slidesToShow: 6,
        slidesToScroll: 6,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
        ],
    });
}

function tabs() {
    jQuery('.tabs .tab a').on('click', function (e) {
        e.preventDefault();
        const img_url = jQuery(this).attr('data-href');
        jQuery('.tabs .tab').removeClass('active');
        jQuery(this).parent().addClass('active');
        jQuery('.tabs-content-item').removeClass('active');
        jQuery(img_url).addClass('active');
    });
    jQuery('.tabs-content .plans-nav a').on('click', function (e) {
        e.preventDefault();
        const img_url = jQuery(this).attr('data-href');
        jQuery('.tabs-content .plans-nav a').removeClass('active');
        jQuery(this).addClass('active');
        jQuery('.tabs-content .plans-image img').attr('src', img_url);
    });
}

function menuActiveItems() {
    const linkHash = (href) => {
        if (href) {
            return href.split('#').length > 1 ? `#${href.split('#')[1].toLowerCase().trim()}` : '';
        }
        return '';
    };

    const updateActive = (elm, currentHash = window.location.hash) => {
        const href = elm.attr('href');
        if (href) {
            const hash = linkHash(href);
            if (hash === currentHash) {
                elm.parent().addClass('current-menu-item');
            } else {
                elm.parent().removeClass('current-menu-item');
            }
        }
    };

    if (window.location.hash) {
        jQuery('.menu-wrapper').find('a').each(function () {
            updateActive(jQuery(this));
        });
    }

    jQuery(window).on('hashchange', () => {
        if (window.location.hash) {
            jQuery('.menu-wrapper').find('a').each(function () {
                updateActive(jQuery(this));
            });
            setTimeout(function () {
                jQuery('html, body').stop().animate({
                    scrollTop: jQuery(window.location.hash).offset().top - 150,
                }, 200);
            }, 500);
        }
    });
}

function popup() {
    const body = jQuery('body');
    const popupElm = jQuery('.popup');
    const storage = window.sessionStorage;
    const params = new URLSearchParams(window.location.search);
    let disablePopups = false;
    if (params.has("nopopups")) {
        params.delete("nopopups");
        if (params) {
            history.pushState(null, null, `?${params.toString()}`);
        } else {
            history.pushState(null, null, params.toString());
        }
        disablePopups = true;
    }

    popupElm.each(function () {
        const currentPopup = jQuery(this);
        const delay = currentPopup.attr('data-delay') ?? 5;
        if (!disablePopups) {
            setTimeout(function () {
                const id = currentPopup.attr('data-popup');
                if (!storage.getItem(`popup-${id}`)) {
                    currentPopup.addClass('popup--open');
                    setTimeout(function () {
                        body.addClass('has-popup-open');
                    }, 500);
                }
            }, delay * 1000);
        } else {
            const id = currentPopup.attr('data-popup');
            storage.setItem(`popup-${id}`, '1');
        }
    });

    popupElm.find('.popup-close, a').on('click', function () {
        if (body.hasClass('has-popup-open')) {
            const closestPopup = jQuery(this).closest('.popup').first();
            const id = closestPopup.attr('data-popup');
            closestPopup.removeClass('popup--open');
            if (jQuery('.popup--open').length === 0) {
                body.removeClass('has-popup-open');
                storage.setItem(`popup-${id}`, '1');
            }
        }
    });

    popupElm.on('click', function (e) {
        if (e.target !== this) {
            return;
        }

        if (body.hasClass('has-popup-open')) {
            jQuery(this).removeClass('popup--open');
            const id = jQuery(this).attr('data-popup');
            storage.setItem(`popup-${id}`, '1');

            if (jQuery('.popup.popup--open').length === 0) {
                body.removeClass('has-popup-open');
            }
        }
    });
}

jQuery(document).ready(function () {
    "use strict";

    gallery();
    eventGallery();
    eventMore();
    visualSlider();
    contentJS();
    eventsFilter();
    loadPosts();
    mobileNav();
    logosSlider();
    tabs();
    menuActiveItems();
    popup();

    if (typeof calendar_options !== 'undefined') {
        calendar();
    }

    jQuery(window).scroll(function () {
        const header = jQuery('body');
        const scroll = jQuery(window).scrollTop();
        if (scroll >= 70) {
            header.addClass('sticky');
        } else {
            header.removeClass('sticky');
        }
    });
});
